import { combineReducers } from 'redux-immutable';
import resourcesReducer from './resources.js';
import sessionFilesReducer from './sessionFiles.js';

export default combineReducers({
  resource: resourcesReducer,
  sessionFile: sessionFilesReducer,
});
